import { call, put, takeLatest } from 'redux-saga/effects'

import * as api from '../api'
import {
  loaded,
  setSessionRequest,
  setSessionSuccess,
  setSessionFailure,
  setSessionFulfill,
  BootstrapTypes,
  SessionPayload,
  InitAction,
} from '../actions'

/**
 * @todo To handle redirections to log in/out pages
 */
export function* bootstrap({ payload: { replace } }: InitAction): Generator {
  try {
    yield put(setSessionRequest())
    const userData: SessionPayload = yield call(api.getSession)
    yield put(setSessionSuccess(userData))
    if (!('user' in userData)) {
      replace('/login')
    }
  } catch (err) {
    /**
     * If there's an error on the Session cookie,
     * set msg if needed
     */
    let msg = { message: ''}
    yield put(setSessionFailure(msg))
  } finally {
    yield put(setSessionFulfill())
    yield put(loaded())
  }
}

export const appSaga = [
  takeLatest(BootstrapTypes.INIT, bootstrap),
  takeLatest('LOGIN_SUCCESS', bootstrap),
]



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/app.ts